import { IChangeObjectID } from '../../../actions/userObject/changeUserIdObject'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IChangeObjectID,
): IUserObjectStore {
  return {
    ...state,
    userObjectId: action.id,
  }
}
